import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';
import {purchaseStatementsService} from '@store/invoices/purchaseStatements/purchaseStatements.service';
import {PurchaseStatementsState} from '@store/invoices/purchaseStatements/purchaseStatements.store';

type SearchPurchaseStatementParams = Partial<PurchaseStatementsState>

export const searchPurchaseStatementsEffect = createEffectFn((params$: Observable<SearchPurchaseStatementParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => purchaseStatementsService.getPurchaseStatements().pipe(catchError(() => EMPTY))),
  );
});
